import { takeLatest, select, put, call, race, take } from 'redux-saga/effects';
import { Customers } from '@grandvisionhq/api-client';
import { Selectors, State, getToken } from '@grandvisionhq/auth';
import { toast } from '@grandvisionhq/common';
import { fetchList, addAddress, deleteAddress, editAddressSave, fetchListFailed, fetchListSuccess, addAddressFailed, addAddressSuccess, deleteAddressFailed, toggleModal, deleteAddressConfirm, deleteAddressSuccess, editAddressFailed, editAddressSuccess } from './actions.js';

function* onFetchAddressBook() {
    const authState = yield select(Selectors.getAuth);
    if (!State.isLoggedIn(authState)) {
        yield put(fetchListFailed(new Error('User needs to be logged in to fetch addresses')));
        return;
    }
    const customerId = authState.userId;
    try {
        const accessToken = yield call(getToken);
        const result = yield call(Customers.Addresses.list, authState.apiUrl, {
            customerId,
            accessToken
        });
        yield put(fetchListSuccess(result));
    } catch (err) {
        yield put(fetchListFailed(err));
    }
}
function* onAddAddress(action) {
    const authState = yield select(Selectors.getAuth);
    if (!State.isLoggedIn(authState)) {
        yield put(addAddressFailed(new Error('User needs to be logged in to add an address to the address book')));
        return;
    }
    const customerId = authState.userId;
    try {
        const accessToken = yield call(getToken);
        const newAddress = yield call(Customers.Addresses.create, authState.apiUrl, {
            customerId,
            accessToken,
            address: action.payload
        });
        yield put(addAddressSuccess(newAddress));
    } catch (err) {
        yield put(addAddressFailed(err));
    }
}
function* onDeleteAddress(action) {
    const authState = yield select(Selectors.getAuth);
    if (!State.isLoggedIn(authState)) {
        yield call(toast.failed, 'account.addressBook.delete.authFailed');
        yield put(deleteAddressFailed(new Error('User needs to be logged in to add an address to the address book')));
        return;
    }
    const customerId = authState.userId;
    const addressId = action.payload;
    const { cancel  } = yield race({
        cancel: take(toggleModal.type),
        confirm: take(deleteAddressConfirm.type)
    });
    if (cancel) {
        return;
    }
    try {
        const accessToken = yield call(getToken);
        yield call(Customers.Addresses.deleteAddress, authState.apiUrl, {
            customerId,
            accessToken,
            addressId
        });
        yield call(toast.success, 'account.addressBook.delete.success');
        yield put(deleteAddressSuccess(addressId));
    } catch (err) {
        yield call(toast.failed, 'account.addressBook.delete.failed');
        yield put(deleteAddressFailed(err, addressId));
    }
}
function* onEditAddress(action) {
    const authState = yield select(Selectors.getAuth);
    if (!State.isLoggedIn(authState)) {
        yield put(editAddressFailed(new Error('User needs to be logged in to edit an address in the address book')));
        return;
    }
    const customerId = authState.userId;
    const { address: editedAddress , id  } = action.payload;
    try {
        const accessToken = yield call(getToken);
        yield call(Customers.Addresses.edit, authState.apiUrl, {
            customerId,
            accessToken,
            address: editedAddress,
            id
        });
        yield put(editAddressSuccess(editedAddress));
    } catch (err) {
        yield put(editAddressFailed(err));
    }
}
var addressBookSagas = [
    takeLatest(fetchList.type, onFetchAddressBook),
    takeLatest(addAddress.type, onAddAddress),
    takeLatest(deleteAddress.type, onDeleteAddress),
    takeLatest(editAddressSave.type, onEditAddress), 
];

export { addressBookSagas as default, onAddAddress, onDeleteAddress, onEditAddress, onFetchAddressBook };
//# sourceMappingURL=sagas.js.map
